import { useEffect, useState } from 'react';
import { generateToolRegistryToken, GenerateToolRegistryTokenResponse } from "../../api/tools";
import { getAllCorporations } from '../../helpers/corporation';
import { Alert, AlertTypes } from '../Alert';
import { Button, ButtonTypes } from "../Button";
import { Modal } from "../Modal";
import { SelectInput } from "../SelectInput";
import { Spinner, SpinnerColor } from '../Spinner';

export default function GenerateToolRegistryToken() {

    const [corporationId, setCorporationId] = useState(0);
    const [allCorporations, setAllCorporations] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    async function handleSubmit(e: Event) {
        e.preventDefault();
        setShowModal(true);
    }


    useEffect(() => {
        getAllCorporations().then(corporations => {
            if (corporations) {
                setAllCorporations(corporations as any);
            }
        })
    }, [])

    async function submit(e: Event) {
        e.preventDefault();
        setIsLoading(true);
        try {
            let response: GenerateToolRegistryTokenResponse;
            response = await generateToolRegistryToken({ corporationId});
            setIsLoading(false);
            setShowModal(false);
            
        } catch (err) {
            setErrorResponse(err as string);
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="card p-4 mb-4 full-width">
                <h5 className="card-header">Add Tool Registry Token to Corporation</h5>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <SelectInput
                                label="Corporation"
                                options={
                                    allCorporations
                                }
                                placeholder={
                                    {
                                        value: '',
                                        label: 'Select corporation'
                                    }
                                }
                                value={corporationId}
                                onValue={(option: any) => setCorporationId(option.value)}
                            />
                
                        </div>
                        <div className="pt-4">
                            <Button type={ButtonTypes.PRIMARY} text="Add Token to Corporation" className={!corporationId ? 'disabled' : ''} onPress={(e: Event) => handleSubmit(e)} />
                        </div>
                        {showModal && (
                            <Modal
                                title="Details about the action"
                                onConfirm={(e: Event) => submit(e)}
                                onCancel={(e: Event) => setShowModal(false)}
                            >
                                <div>
                                    Are you sure you want to continue?
                                </div>
                            </Modal>
                        )}
                        {errorResponse && (
                            <div className="pt-4">
                                <Alert type={AlertTypes.DANGER} text={errorResponse} />
                            </div>
                        )}
                        {isLoading && (
                            <Spinner color={SpinnerColor.PRIMARY} />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}